/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import {Component, Inject} from '@angular/core';
import {NbAuthService, NbLoginComponent, NB_AUTH_OPTIONS} from '@nebular/auth';
import { ChangeDetectorRef } from '@angular/core';
import { Router } from '@angular/router';
import * as Jquery from '../../visuals/jquery/jquery-3.4.1.min';
// import { NbAuthSocialLink } from '../../auth.options';
// import { NbAuthService } from '../../services/auth.service';

import {RequestService} from '../../services/';
import {AuthService} from '../services/';

interface ResponseInt{
    ok:boolean;
    data:boolean;
    session: boolean;
    token: string;
}

@Component({
    selector: 'ngx-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss'],
})
export class NgxLoginComponent extends NbLoginComponent  {

    constructor( service: NbAuthService, cd: ChangeDetectorRef, @Inject(NB_AUTH_OPTIONS) protected options = {}, router: Router, protected auth: AuthService, protected req: RequestService) {
        super(service, options, cd, router);
        this.rememberMe = false;

        this.req.makeActionsRequest('getUpdate', {}).subscribe( (d: ResponseInt) => {
            if(d.ok && d.data){
                // console.log('session is ok');
                let token = "true";
                if(typeof d.token != 'undefined' && d.token != null){
                    token = d.token;
                }
                // console.log('session is ok, token ', token);
                this.auth.login(token);
            }
        });

        // ESTILOS IMPOSIBLES DE METER SI NO ES JQUERY
        Jquery('nb-card-header').remove();
        Jquery('nb-card').css('height', '100%').css('background-image', 'url("../../../assets/images/backgrounds/login1.jpg")').css('background-size', 'cover').css('background-position', 'center center');
        Jquery('nb-layout-column').css('padding', '0px');
    }

    login(): void {
        // EVITAMOS QUE LOS USUARIOS DE DESAFÍOS MOP ENTREN A LA PLATAFORMA, SOLUCIÓN PROVISIONAL
        //if (this.user.email != "francisca.espinoza@mop.gov.cl" && this.user.email != "marcelo.marquez@mop.gov.cl") {
          this.req.makeActionsRequest('login', {'user': this.user.email, pass: this.user.password, captcha: this.user.captcha}).subscribe( (d: ResponseInt) => {
            // console.log('login done', d);
            if(d.ok && d.data){
                let token = "true";
                if(typeof d.token != 'undefined' && d.token != null){
                    token = d.token;
                }
                this.auth.login(token);
            } else{
              alert('Login incorrecto');
            }
          });


    }

}
